import type { HeroMediaItem } from "./types";
import { altTextMaxCharacters, maxMediaItems } from "./content-limits";
import { lengthError, type FieldError } from "./field-validation";
import { isAllowedLinkUrl, isAllowedVideoUrl } from "./link-validation";

export function mediaErrors(items: readonly HeroMediaItem[]): FieldError[] {
  const errors: FieldError[] = [];

  if (items.length > maxMediaItems) {
    errors.push({
      field: "hero_media",
      message: `hero media: at most ${maxMediaItems} items`,
    });
  }

  items.forEach((item, i) => {
    const altErr = lengthError({
      field: `hero_media[${i}].alt`,
      label: `media ${i + 1} alt text`,
      value: item.alt,
      max: altTextMaxCharacters,
    });

    if (altErr) errors.push(altErr);

    const validSource =
      item.kind === "video_url"
        ? isAllowedVideoUrl(item.src)
        : isAllowedLinkUrl(item.src);

    if (!validSource) {
      errors.push({
        field: `hero_media[${i}].src`,
        message: `media ${i + 1}: use an HTTPS image, supported video host, or direct video file without credentials or an IP address`,
      });
    }

    if (item.poster == null && item.kind === "video_url") {
      errors.push({
        field: `hero_media[${i}].poster`,
        message: `media ${i + 1}: a poster image is required for a video URL`,
      });
    } else if (item.poster != null && !isAllowedLinkUrl(item.poster)) {
      errors.push({
        field: `hero_media[${i}].poster`,
        message: `media ${i + 1}: use an HTTPS poster URL without credentials or an IP address`,
      });
    }
  });
  return errors;
}
